import { useImpuestoEmpresa } from "api/ImpuestoEmpresa.hook"
import { getImpuestoEmpresaNew } from "api/ImpuestoEmpresa.service"
import axios from "axios"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useCallback, useEffect, useState } from "react"
import { setTiposImpuestosArticulos } from "routes/globalSlice"

export const useTaxes = (entidad: $TSMigrationFixMe) => {
  const dispatch = useDispatch()
  const [taxes, setTaxes] = useState([])
  const [conceptTaxes, setConceptTaxes] = useState([])
  const [taxesGroup, setTaxesGroup] = useState([])
  const [taxesDefault, setDefault] = useState([])

  const { impuestoEmpresa: tiposImpuestosGenerales } = useImpuestoEmpresa()

  const { isLibrado } = useSelector((state) => state.newDocumento)

  const getDefault = useCallback(async () => {
    // @ts-expect-error TS(2345): Argument of type 'ImpuestoEmpresaReadingDtoProps[]...
    setDefault(tiposImpuestosGenerales)
  }, [tiposImpuestosGenerales])

  const getAllTaxes = useCallback(async () => {
    const pageActive = window.location.pathname
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    const filterTaxesRetenciones = tiposImpuestosGenerales.filter(
      ({ tipo }) => tipo === (isLibrado ? 0 : 1)
    )
    if (
      pageActive === "/perfil/impuestos" ||
      pageActive.includes("/contactos") ||
      pageActive.includes("documentos/pedidos") ||
      pageActive.includes("documentos/albaranes") ||
      pageActive.includes("/documentos/presupuestos") ||
      pageActive.includes("crear-pedido") ||
      pageActive.includes("crear-albaran") ||
      pageActive.includes("crear-factura")
    ) {
      // @ts-expect-error TS(2345): Argument of type 'ImpuestoEmpresaReadingDtoProps[]...
      setTaxes(tiposImpuestosGenerales)
      dispatch(setTiposImpuestosArticulos(filterTaxesRetenciones))
    } else {
      dispatch(setTiposImpuestosArticulos(filterTaxesRetenciones))
      // @ts-expect-error TS(2345): Argument of type 'ImpuestoEmpresaReadingDtoProps[]...
      setTaxes(filterTaxesRetenciones)
    }
  }, [dispatch, isLibrado, tiposImpuestosGenerales])

  const getAllTaxesGroup = useCallback(async () => {
    const { data } = await axios.get("/GrupoImpuesto")

    setTaxesGroup(data)
  }, [])

  const getConceptTaxesRetention = useCallback(
    async (type = 0) => {
      const determineTypeDocument = isLibrado ? 0 : 1

      const data = await getImpuestoEmpresaNew({
        EsActivo: true,
        TipoGrupoImpuesto: determineTypeDocument,
        // @ts-expect-error TS(2322): Type 'number' is not assignable to type 'TipoImpue...
        TipoImpuestoEmpresa: type,
        IsPagingEnabled: false,
      })

      // @ts-expect-error TS(2345): Argument of type 'GetAllImpuestosDtoProps[] | null...
      setConceptTaxes(data.items)
    },
    [isLibrado]
  )

  const setTaxesStatus = useCallback(async (taxe: $TSMigrationFixMe) => {
    const mappedStatus = {
      id: taxe.id,
      cuentaContableEmpresaId: taxe?.cuentaContableEmpresa?.id,
      esActivo: taxe.esActivo,
      grupoImpuestoId: taxe.grupoImpuesto.id,
      nombre: taxe.nombre,
      tipoImpuestoEmpresa: taxe.tipo,
      valor: Math.abs(taxe.valor),
    }
    await axios.put("/ImpuestoEmpresa", mappedStatus)
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    document.getElementById("refresh-list").click()
  }, [])

  const updateTaxe = useCallback(async (mappedStatus: $TSMigrationFixMe) => {
    await axios.put("/ImpuestoEmpresa", mappedStatus)
  }, [])

  const getTaxeById = useCallback(async (taxeId: $TSMigrationFixMe) => {
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    const filterTaxesRetenciones = tiposImpuestosGenerales.find(
      ({ id }) => id === taxeId
    )
    return filterTaxesRetenciones
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // FIX: Multiple calls to grupoImpuesto. We must analyze the impact of this change
  useEffect(() => {
    getAllTaxes()
    getAllTaxesGroup()
    getConceptTaxesRetention()
    getDefault()
  }, [
    entidad,
    getAllTaxes,
    getAllTaxesGroup,
    getConceptTaxesRetention,
    getDefault,
  ])
  return {
    taxes,
    taxesDefault,
    taxesGroup,
    conceptTaxes,
    tiposImpuestosGenerales,
    getAllTaxes,
    setTaxesStatus,
    updateTaxe,
    getAllTaxesGroup,
    getConceptTaxesRetention,
    getDefault,
    getTaxeById,
  }
}
